import React from "react";
import SocialLinks from "../SocialLinks/SocialLinks"; // Import SocialLinks component
import { ReactComponent as Logo } from "../../resources/assets/images/kozeelogo.svg"; // Import Kozee Logo
import "./Footer.css"; // Import Footer CSS

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Left-Aligned Logo & Text */}
        <div className="footer-left">
          <Logo className="footer-logo" />
          <p className="footer-text">&copy; {new Date().getFullYear()} Kozee. All Rights Reserved.</p>
        </div>

        {/* Centered Social Links */}
        <div className="footer-social">
          <SocialLinks />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
